import { 
    GET_REGION_PICKER_DATA_REQUEST, 
    GET_REGION_PICKER_DATA_SUCCESS, 
    GET_REGION_PICKER_DATA_ERROR,
    UPDATE_REGION_PICKER_VALUE,
    RESET_REGION_PICKER_ITEMS
} from '../action-types'

const initialState = {
    regionId: null,
    status: 'idle',
    items: []
}
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_REGION_PICKER_DATA_REQUEST:
            return {...state, status: 'loading' }
        case GET_REGION_PICKER_DATA_SUCCESS:
            return {
                ...state,
                status: 'fulfilled',
                items: payload.items
            }
        case GET_REGION_PICKER_DATA_ERROR:
            return { ...state, status: 'error' }
        case UPDATE_REGION_PICKER_VALUE:
            return { ...state, storeId: payload }
        case RESET_REGION_PICKER_ITEMS:
            return {...state, status: 'idle', items: [] }
        default:
            return state
    }
}